import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MultiSelectButton from './multi-select-button';
import Icon, { NAMES } from '@ifit/react-icons';
import { white80 } from '../../theme/colors';

import '../single-select/index.css';

export default class MultiSelect extends Component {
  static propTypes = {
    selectOptions: PropTypes.array.isRequired,
    initialValue: PropTypes.array.isRequired,
    setActiveOptions: PropTypes.func.isRequired,
    displayIconVersion: PropTypes.bool,
    seeMoreButtonOptions: PropTypes.number
  };

  constructor(props) {
    super(props);

    this.state = {
      activeOptions: props.initialValue,
      optionsExpanded: false
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ activeOptions: nextProps.initialValue });
  }

  handleSelectOption = (id) => {
    const activeOptions = this.state.activeOptions;
    const optionIndex = activeOptions.indexOf(id);

    optionIndex !== -1 ? activeOptions.splice(optionIndex, 1) : activeOptions.push(id);
    this.setState({ activeOptions });
    this.props.setActiveOptions(activeOptions);
  }

  renderSelectOptions() {
    const passedOptions = this.props.selectOptions;
    const selectOptions = passedOptions.map((selectOption, index) => {
      if (this.props.seeMoreButtonOptions && index >= this.props.seeMoreButtonOptions && !this.state.optionsExpanded) return null;
      return (
        <MultiSelectButton
          key={ selectOption.optionText }
          id={ index }
          optionText={ selectOption.optionText }
          subtext={ selectOption.subtext }
          iconText={ selectOption.iconText }
          handleSelectOption={ this.handleSelectOption }
          activeOptions={ this.state.activeOptions }
          displayIconVersion={ this.props.displayIconVersion }
        />
      );
    });

    return selectOptions;
  }

  showMoreOptions = () => {
    this.setState({ optionsExpanded: true });
  }

  render() {
    return (
      <div className={ classNames('select-options clearfix', { 'select-options-icons': this.props.displayIconVersion }) }>
        { this.renderSelectOptions() }
        { (this.props.seeMoreButtonOptions && !this.state.optionsExpanded) &&
          <a onClick={ this.showMoreOptions } className="see-more-button">
            See More
            <Icon
              className="down-arrow"
              name={ NAMES.CHEVRON_DOWN }
              color={ white80 }
              size={ 10 }
              unitSize="px"
            />
          </a>
        }
      </div>
    );
  }
}
